<template>
    <modal
        name="modal-reset-password-email-success"
        height="auto"
        @before-close="beforeClose"
    >
        <div class="container">
            <div class="img-wrapper">
                <img class="img" src="../../assets/images/correo_enviado.svg"/>
            </div>
            <div class="body-title-wrapper">
                <div class="body-title">¡Revisa tu correo!</div>
            </div>
            <div class="body-content-wrapper">
                <div class="body-content">Hemos envíado un enlace para configurar tu contraseña al correo: <span class="email">{{email}}</span></div>
            </div>
            <div class="buttons-wrapper">
                <button @click="close" class="primary-button-xs">Entendido</button>
            </div>
        </div>
    </modal>
</template>
<script>
import Auth from '@/mixins/auth'
export default {
    name:"modal-reset-password-email-success",
    props: {
        email: "",
    },

    methods: {
        beforeClose(event) {
            this.logout()
        },
        
        close() {
            this.logout()
        },

        logout() {
            Auth.removeSession()
            this.$store.commit('setAuth', null);
            this.$router.push('/');
        }

    }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
.container{
    padding: 75px 35px 0 35px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.14);
    height: auto;
}
.img-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.img{
    width: 260px;
    height: 175px;
}
.header-title{
    color: #2a2a2e;
    font-family: 'miraimedium';
    font-size: 1.125em;
}
.body-title-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.body-content-wrapper {
    justify-content: center;
    margin-bottom: 30px;
}
.body-content {
    font-size: 20px;
    color: $bold-grey;
    text-align: center;
    margin-bottom: 40px;
}
.body-title {
    font-size: 28px;
    color: $primary;
}
.buttons-wrapper{
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}
.email {
    font-weight: bold;
}
</style>